import React from 'react';

import { AttributesActions } from '../components/AttributesActions';
import { PositionInput } from '../components/PositionInput';
import { AttributesProps } from '../service/attributes.interface';

export const getColumns = (maxPosition: number) => {
    return [
        {
            title: '№',
            dataIndex: 'position',
            key: 'position',
            width: '100px',
            render: (_, record: AttributesProps) => (
                <PositionInput {...record} />
            ),
        },
        {
            title: 'Название характеристики',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Действие',
            dataIndex: 'type',
            key: 'type',
            width: '116px',
            render: (_, record: AttributesProps) => (
                <AttributesActions maxPosition={maxPosition} {...record} />
            ),
        },
    ];
};
